import React from 'react';
import { SHOP_URL, SUPPORT_EMAIL } from '../data/content';
export function Footer() {
  return <footer className="w-full border-t border-line bg-paper py-12" data-id="element-60" data-mp="3gfsoqi9xf4pm">
      <div className="mx-auto max-w-content px-5 md:px-8" data-id="element-61" data-mp="3gh3swj7aaeh9">
        <div className="flex flex-col gap-6 md:flex-row md:items-start md:justify-between" data-id="element-62" data-mp="32p5qssbzpiul">
          <p className="text-lg font-extrabold tracking-tight text-ink" data-id="element-63" data-mp="36q92d2n08sq0">NUEVO NIVEL™</p>
          <div className="flex flex-col gap-1.5 text-sm font-medium text-ink-muted md:items-end" data-id="element-64" data-mp="3ug3f7k7bqha9">
            <a href={`mailto:${SUPPORT_EMAIL}`} className="transition-colors duration-150 ease-out hover:text-accent-dark" data-id="element-65" data-mp="37o5ytxdtvcu">
              {SUPPORT_EMAIL}
            </a>
            <a href={SHOP_URL} className="transition-colors duration-150 ease-out hover:text-accent-dark" data-id="element-66" data-mp="3qc40n75ltsjj">
              www.nuevonivel.shop
            </a>
          </div>
        </div>
        <p className="mt-8 max-w-2xl text-xs leading-relaxed text-ink-muted" data-id="element-67" data-mp="2ew700loelk6h">
          © Nuevo Nivel™ 2025 — Producto informativo y educativo. No reemplaza consulta médica
          profesional ni el juicio clínico del profesional.
        </p>
      </div>
    </footer>;
}